module.exports = __webpack_public_path__ + "static/optimised-bfc5a3b0f7c558f57a1125f3a116df67.mp4";